/* global angular */

/**
* gc.emoticon Module
*
* Deals various things with emojis
*/
angular
.module('gc.emoticon', [])
.service('EmoticonService', ['$window', function($window) {
  'use strict';

  var EMOJI_ULR_TEMPLATE = 'https://twemoji.maxcdn.com/2/svg/%%code_point%%.svg';
  var EMOTICON_REGEXP = '([\ud83c-\ud83e][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u2639|\ue50a|\u27b0|\u2797|\u2796|\u2795|\u2755|\u2754|\u2753|\u274e|\u274c|\u2728|\u270b|\u270a|\u2705|\u26ce|\u23f3|\u23f0|\u23ec|\u23eb|\u23ea|\u23e9|\u27bf|\u00a9|\u00ae|(\u3299|\u303d|\u3030|\u2b55|\u2b50|\u2b1c|\u2b1b|\u2b07|\u2b06|\u2b05|\u2935|\u2934|\u27a1|\u2764|\u2757|\u2747|\u2744|\u2734|\u2733|\u2716|\u2714|\u2712|\u270f|\u270c|\u2709|\u2708|\u2702|\u26fd|\u26fa|\u26f5|\u26f3|\u26f2|\u26ea|\u26d4|\u26c5|\u26c4|\u26be|\u26bd|\u26ab|\u26aa|\u26a1|\u26a0|\u2693|\u267f|\u267b|\u3297|\u2666|\u2665|\u2663|\u2660|\u2653|\u2652|\u2651|\u2650|\u264f|\u264e|\u264d|\u264c|\u264b|\u264a|\u2649|\u2648|\u263a|\u261d|\u2615|\u2614|\u2611|\u260e|\u2601|\u2600|\u25fe|\u25fd|\u25fc|\u25fb|\u25c0|\u25b6|\u25ab|\u25aa|\u24c2|\u231b|\u231a|\u21aa|\u21a9|\u2199|\u2198|\u2197|\u2196|\u2195|\u2194|\u2139|\u2122|\u2049|\u203c|\u2668)([\uFE0E\uFE0F]))';
  var EMOTICON_REGEXP_SINGLE = new RegExp(EMOTICON_REGEXP, 'g');
  var EMOTICON_REGEXP_HTML = new RegExp('<img class="emoji" draggable="false" alt="' + EMOTICON_REGEXP + '" src="https[^\"]*\.svg"[^>]*>', 'g');

  var that = this;

  /**
   * Determine if this browser supports emoji.
   * https://gist.github.com/mathisonian/7885295
   */
  function testEmoticons() {
    if (!$window.document.createElement('canvas').getContext) {
      return false;
    }
    var context = $window.document.createElement('canvas').getContext('2d');
    if (typeof context.fillText != 'function') {
      return false;
    }
    // Testing here the upside-down face "🙃", which is from unicode v8.
    var smile = String.fromCharCode(55357) + String.fromCharCode(56899);

    try {
      context.textBaseline = 'top';
      context.font = '32px Arial';
      context.fillText(smile, 0, 0);
    } catch (e) {
      // only happens in overlay mode on FF
      return true;
    }

    return context.getImageData(16, 16, 1, 1).data[0] !== 0;
  }

  this.supportsEmoticons = testEmoticons();

  /**
   * Transforms an unicode character to a twemoji "code point"
   * Extracted from https://github.com/twitter/twemoji/
   */
  function toCodePoint(unicodeSurrogates, sep) {
    var
      r = [],
      c = 0,
      p = 0,
      i = 0;
    while (i < unicodeSurrogates.length) {
      c = unicodeSurrogates.charCodeAt(i++);
      if (p) {
        r.push((0x10000 + ((p - 0xD800) << 10) + (c - 0xDC00)).toString(16));
        p = 0;
      } else if (0xD800 <= c && c <= 0xDBFF) {
        p = c;
      } else {
        r.push(c.toString(16));
      }
    }
    return r.join(sep || '-');
  }

  this.emoticonToImageUrl = function(emoticon) {
    var codePoint = toCodePoint(emoticon);

    // Fixes a bug with the heart ❤
    codePoint = codePoint.replace('-fe0f', '');

    return EMOJI_ULR_TEMPLATE.replace('%%code_point%%', codePoint);
  };

  // Takes 😄 and returns an <img> DOM element ready to insert
  this.emoticonToImgElement = function(emoticon) {
    // If you change anything here, please also change the replaceHtmlImgByUnicode function
    var img = $window.document.createElement('img');
    img.className = 'emoji';
    img.draggable = false;
    img.alt = emoticon;
    img.src = this.emoticonToImageUrl(emoticon);
    return img;
  };

  // Takes 😄 and returns <img class="emoji" draggable="false" alt="😄" src="https://twemoji.maxcdn.com/svg/1F600.svg">
  this.emoticonToImage = function(emoticon) {
    return that.emoticonToImgElement(emoticon).outerHTML;
  };

  // Takes an HTML string, finds all emoticon images and replaces them by unicode chars
  this.replaceHtmlImgByUnicode = function(html) {
    // We add a "thin space" after the emoticon for lisibility: \u2009
    return html.replace(EMOTICON_REGEXP_HTML, '$1\u2009');
  };

  // Takes an HTML string, finds all unicode chars and replace them by emoticons
  this.replaceUnicodeByHtmlImg = function(html) {
    return html.replace(EMOTICON_REGEXP_SINGLE, this.emoticonToImage);
  };

}])
.filter('emoticonsFallback', ['EmoticonService', function (EmoticonService) {
  return function (text, length, expanded) {
    return EmoticonService.supportsEmoticons ? text : EmoticonService.replaceUnicodeByHtmlImg(text);
  };
}]);
